var io = require('socket.io-client');

function noop() {
};

var ChatClient = function(options) {
    var callbacks = {};
    callbacks.onConnect = (typeof options.onConnect == "function") ? options.onConnect : noop;
    callbacks.onJoinRoom = (typeof options.onJoinRoom == "function") ? options.onJoinRoom : noop;
    callbacks.onConnectError = (typeof options.onConnectError == "function") ? options.onConnectError : noop;
    callbacks.onReconnecting = (typeof options.onReconnecting == "function") ? options.onReconnecting : noop;
    callbacks.onDisconnect = (typeof options.onDisconnect == "function") ? options.onDisconnect : noop;
    callbacks.onJoin = (typeof options.onJoin == "function") ? options.onJoin : noop;
    callbacks.onLeave = (typeof options.onLeave == "function") ? options.onLeave : noop;
    callbacks.onKickout = (typeof options.onKickout == "function") ? options.onKickout : noop;
    callbacks.onUser = (typeof options.onUser == "function") ? options.onUser : noop;
    callbacks.onUsers = (typeof options.onUsers == "function") ? options.onUsers : noop;
    callbacks.onRights = (typeof options.onRights == "function") ? options.onRights : noop;
    callbacks.onSpeaker = (typeof options.onSpeaker == "function") ? options.onSpeaker : noop;
    callbacks.onVideo = (typeof options.onVideo == "function") ? options.onVideo : noop;
    callbacks.onVideos = (typeof options.onVideos == "function") ? options.onVideos : noop;
    callbacks.parseUser = (typeof options.parseUser == "function") ? options.parseUser : noop;

    this._roomopt = null;
    this._callbacks = callbacks;
    this.videos = [];
}

ChatClient.prototype.connect = function(host) {
    this.socket = io.connect(host, {multiplex: false, transports: ['websocket'],
                                    pingInterval: 30000, pingTimeout: 30000});
    this.socket.on('connect', () => {
        this._callbacks.onConnect(this);
        if (this._roomopt && this._roomopt.autojoin) {
            this.socket.emit('join', this._roomopt, (response) => {
                if (!response.error) {
                    this.roomid = this._roomopt.roomid;
                    this.userid = response.data.userid;
                    this.videos = [];
                }
                this._callbacks.onJoinRoom(response, this);
            });
        }
    });

    this.socket.on('connect_error', (error) => {
        this._callbacks.onConnectError(error.message, this);
    });

    this.socket.on('reconnecting', () => {
        this._callbacks.onReconnecting(this);
    });

    this.socket.on('disconnect', () => {
        this._callbacks.onDisconnect(this);
        //this._roomopt = null;
        this.roomid = 0;
        this.userid = 0;
    });

    this.socket.on('join', (user, opts) => {
        this._callbacks.parseUser(user);
        this._callbacks.onJoin(user, opts);
    });

    this.socket.on('leave', (userid, error, opts) => {
        if (userid === this.userid) {
            // kickout room?
            this._roomopt = null;
            this.roomid = 0;
            this.userid = 0;
        }
        this._callbacks.onLeave(userid, error, opts);
    });

    this.socket.on('kickout', (info) => {
        // kickout room?
        this._roomopt = null;
        this.roomid = 0;
        this.userid = 0;
        this._callbacks.onKickout(info);
    });

    this.socket.on('user', (user) => {
        this._callbacks.parseUser(user);
        this._callbacks.onUser(user);
    });

    this.socket.on('users', (users, reset, update) => {
        for (var i in users) {
            this._callbacks.parseUser(users[i]);
        }
        this._callbacks.onUsers(users, reset, update);
    });

    this.socket.on('rights', (rights) => {
        this._callbacks.onRights(rights);
    });

    this.socket.on('speaker', (info) => {
        this._callbacks.onSpeaker(info);
    });

    this.socket.on('video', (video) => {
        this.updateVideo(video);
        this._callbacks.onVideo(video);
    });

    this.socket.on('videos', (videos, reset) => {
        if (reset) {
            this.videos = videos;
        }
        else {
            for (var i in videos) {
                this.updateVideo(videos[i]);
            }
        }
        this._callbacks.onVideos(videos, reset);
    });
}

ChatClient.prototype.joinRoom = function(options, callback) {
    callback = (typeof callback == "function") ? callback : noop;
    this.socket.emit('join', options, (response) => {
        if (!response.error) {
            this._roomopt = options;
            this.roomid = options.roomid;
            this.userid = response.data.uid;
            this.videos = [];
        }

        callback(response);
        if (this._callbacks) {
            this._callbacks.onJoinRoom(response, this);
        }
    });
}

ChatClient.prototype.videoOfIndex = function(index) {
    for (var i in this.videos) {
        if (this.videos[i].index === index) {
            return this.videos[i];
        }
    }
    return null;
}

ChatClient.prototype.updateVideo = function(video) {
    for (var i in this.videos) {
        if (this.videos[i].index === video.index) {
            this.videos[i] = video;
            break;
        }
    }
}

ChatClient.prototype.leaveRoom = function(callback) {
    callback = (typeof callback == "function") ? callback : noop;
    if (!this._roomopt) {
        callback({error: -1, message: "not in room"});
        return;
    }

    this.videos = [];
    if (this.socket) {
        this.socket.emit('leave', (response) => {
            this._roomopt = null;
            this.roomid = 0;
            this.userid = 0;
            callback(response);
        });
    }
}

ChatClient.prototype.close = function() {
    this.leaveRoom();
    if (this.socket) {
        var socket = this.socket;
        delete this.socket;
        socket.disconnect();
    }
    delete this._callbacks;
}

export default ChatClient;
